import React, { SVGAttributes } from 'react';

interface Props extends SVGAttributes<SVGSVGElement> {
  color?: string;
}

export default function OcEnterprise({ color = 'white', ...rest }: Props) {
  return (
    <svg
      width="208"
      height="108"
      viewBox="0 0 208 108"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_2682_670)">
        <path
          d="M41.7681 105.92C50.4644 105.04 67.9142 103.121 71.2787 127.682C75.4843 158.383 73.2033 152.228 69.2115 158.017C66.0181 162.647 60.8478 142.605 58.6618 132.005"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M58.1629 75.3642L58.9129 72.7709C58.9347 72.6956 58.9858 72.6321 59.0548 72.5947L70.0894 66.614C70.3186 66.4898 70.5837 66.704 70.5103 66.9541L63.339 91.4081C63.3116 91.5014 63.2396 91.5751 63.147 91.6048L52.159 95.1172C51.9297 95.1905 51.7148 94.9715 51.7922 94.7436L54.6701 86.2818"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M36.1182 48.3911C36.71 41.5292 33.8208 37.9199 32.3022 36.9729C37.2147 39.8188 42.0558 37.9693 43.8623 36.6888L44.4158 39.7379C47.7816 40.0869 48.5832 35.3972 48.5634 33.0085C48.5328 29.3233 44.5668 24.7731 36.6773 26.5977C28.788 28.4225 24.4581 35.1309 23.2792 38.257C17.6306 36.6607 11.5627 41.0051 9.23477 43.3769C6.82768 45.8389 1.75993 53.2817 5.31849 61.592C10.1196 72.8038 22.8905 70.0196 24.975 68.9169C32.1775 65.1064 35.3785 56.9687 36.1182 48.3911Z"
          fill={color}
        />
        <path
          d="M46.9128 47.1258C46.745 48.2905 46.3256 49.2863 45.8017 49.9558C45.2718 50.6332 44.6853 50.9226 44.1673 50.8437C43.6495 50.7649 43.1698 50.3131 42.8537 49.5068C42.5412 48.7099 42.4206 47.6321 42.5886 46.4673C42.7564 45.3026 43.1758 44.3068 43.6997 43.6373C44.2296 42.9599 44.8161 42.6705 45.3341 42.7494C45.8519 42.8282 46.3316 43.28 46.6476 44.0863C46.9601 44.8832 47.0808 45.961 46.9128 47.1258Z"
          stroke={color}
          strokeWidth="0.732723"
        />
        <path
          d="M44.7538 48.3461C45.1836 48.4116 45.625 47.8199 45.7396 47.0246C45.8543 46.2293 45.5987 45.5315 45.1689 45.466C44.7391 45.4006 44.2977 45.9922 44.1831 46.7875C44.0684 47.5828 44.324 48.2806 44.7538 48.3461Z"
          fill={color}
        />
        <path
          d="M36.1377 47.8139L42.4463 47.092"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M45.0947 39.8578C45.6276 40.9607 47.1999 43.3706 48.8417 44.7196C50.5208 46.0991 50.6626 47.8577 49.5906 49.1247L47.9194 51.118C48.8417 58.3668 47.4829 63.7345 38.8398 66.2332"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M38.7373 54.4261C38.9415 54.4572 39.1316 54.3122 39.1619 54.1023C39.1921 53.8924 39.0511 53.697 38.8469 53.6658C38.6426 53.6347 38.4525 53.7797 38.4223 53.9897C38.392 54.1996 38.533 54.395 38.7373 54.4261Z"
          fill={color}
        />
        <path
          d="M37.3977 57.9522C37.6428 57.9896 37.866 57.8496 37.8962 57.6397C37.9265 57.4297 37.7523 57.2293 37.5072 57.192C37.2622 57.1546 37.0389 57.2946 37.0087 57.5045C36.9784 57.7145 37.1526 57.9149 37.3977 57.9522Z"
          fill={color}
        />
        <path
          d="M40.6574 57.361C40.9025 57.3983 41.1257 57.2584 41.156 57.0484C41.1863 56.8385 41.0121 56.638 40.767 56.6007C40.5219 56.5634 40.2987 56.7033 40.2685 56.9133C40.2382 57.1232 40.4123 57.3237 40.6574 57.361Z"
          fill={color}
        />
        <path
          d="M25.0044 70.3828C14.5314 78.2357 15.7845 88.0287 15.7845 100.131"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M25.2896 70.5166L30.3175 75.0393C30.4807 75.1861 30.7373 75.0992 30.7838 74.8813L32.0945 68.7194C32.1431 68.4909 32.4197 68.4102 32.578 68.5783L35.9818 72.1953"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M35.9819 66.8645C36.2609 67.4018 36.6607 68.2747 37.0352 69.2893C37.5494 70.6817 38.016 72.3412 38.0578 73.7655"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M29.709 79.3942C31.4262 81.7851 41.0962 88.4061 48.0552 81.1415L49.953 79.0264"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M34.4136 102.769C36.6477 102.175 47.2443 96.21 50.3306 90.6675"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M49.5029 83.4604C50.2684 86.2847 50.4838 88.6689 50.3304 90.6656C52.033 89.4648 53.6594 88.5409 53.6594 84.7536C53.6594 82.0748 51.7619 79.7654 50.0451 79.0264"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M35.269 77.1223C35.6626 77.1223 35.9818 76.7286 35.9818 76.243C35.9818 75.7574 35.6626 75.3637 35.269 75.3637C34.8753 75.3637 34.5562 75.7574 34.5562 76.243C34.5562 76.7286 34.8753 77.1223 35.269 77.1223Z"
          fill={color}
        />
        <path
          d="M36.2675 81.3762C36.6612 81.3762 36.9803 80.9825 36.9803 80.4969C36.9803 80.0113 36.6612 79.6176 36.2675 79.6176C35.8738 79.6176 35.5547 80.0113 35.5547 80.4969C35.5547 80.9825 35.8738 81.3762 36.2675 81.3762Z"
          fill={color}
        />
        <path
          d="M43.8401 57.0453C43.7483 57.6168 43.9871 58.798 45.6766 58.9504"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M0.638089 94.926C-2.09913 108.408 4.62987 121.451 8.33652 126.287C13.1281 129.037 17.8791 130.348 22.3077 130.731C31.8461 131.556 39.8888 128.076 43.621 125.407C43.7635 123.698 41.1118 120.703 29.3646 122.403C19.6703 99.425 6.1743 94.5109 0.638089 94.926Z"
          fill={color}
        />
        <path
          d="M44.9756 96.5388C45.5458 97.8089 46.5153 101.038 45.831 103.793"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M37.7046 71.1133C39.0351 72.3346 41.9245 76.0372 42.8369 81.0783"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M42.4097 79.3942C43.3125 80.0781 46.0023 81.0355 49.5378 79.3942"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M138.572 39.4603C137.593 37.9577 135.659 34.5364 135.749 32.872C135.674 32.3326 135.704 31.2538 136.426 31.2538C137.149 31.2538 137.405 32.3326 137.443 32.872"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M173.975 85.3362C176.124 91.3428 182.389 100.845 190.26 90.8002C198.132 80.7556 186.452 60.1861 179.629 51.1569"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M158.368 59.7586C159.197 57.2398 161.852 52.4345 165.832 53.3646C169.813 54.2945 172.241 50.1869 172.958 48.0167"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M153.957 69.9926C150.866 76.1543 150.112 87.8961 153.957 96.6152"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M153.957 69.9926C150.866 76.1543 150.112 87.8961 153.957 96.6152"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M153.958 76.6163C145.363 70.9197 142.762 60.1079 140.726 52.6676C139.779 48.7148 137.469 43.4833 141.178 38.3681C144.888 33.2528 148.304 36.9343 149.547 39.4144L160.404 58.0153"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M173.785 85.1439C176.867 85.7566 183.662 85.948 186.188 81.8125"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M172.93 48.038C174.06 47.4997 176.594 47.715 179.488 51.0361"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M160.041 96.6154L155.517 74.8503C154.951 72.2897 156.06 67.1219 165.017 66.9357C167.355 66.8582 171.805 65.3063 173.953 63.6768C176.066 62.0749 179.496 62.6292 179.835 64.957L183.907 83.2304"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M168.387 94.5229C167.382 94.4396 166.565 94.3177 165.904 94.1693C166.092 95.3315 167.71 97.215 172.678 95.4512C177.645 93.6874 178.512 93.0145 178.324 92.8984"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M173.356 85.0083C170.721 84.3507 166.039 83.7319 168.387 86.5168C170.737 89.3018 166.882 88.3734 164.662 87.5612C163.758 87.2131 161.952 86.8417 161.952 88.1414C161.952 88.5887 162.407 88.9937 163.081 89.3453C164.367 90.0154 166.451 90.4913 167.71 90.6942"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M165.904 94.1693C166.092 95.3315 167.71 97.215 172.678 95.4512C177.645 93.6874 178.512 93.0145 178.324 92.8984"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M163.797 91.6248C163.139 92.2595 162.882 93.4933 165.904 94.1721C166.566 94.3205 167.383 94.4425 168.388 94.5257"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M163.081 89.3458C162.267 89.7675 161.72 90.6531 163.797 91.6231C164.697 92.0429 166.088 92.4788 168.162 92.8995"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M167.281 148.128C156.265 145.993 153.435 112.349 153.398 95.7934C159.086 97.4645 163.97 95.3293 165.701 94.0528C166.966 98.3231 174.656 95.2906 178.344 93.2405C182.909 96.8633 186.175 95.1948 187.756 93.4928L200.467 128.169C201.633 131.959 202.159 140.933 194.935 146.503C187.712 152.073 184.175 145.42 183.309 141.398C182.556 144.531 178.298 150.263 167.281 148.128Z"
          fill={color}
        />
        <path
          d="M182.926 23.7177C190.6 32.3254 184.544 46.201 180.557 52.0627C177.215 47.3424 173.898 47.2422 172.656 47.7822L170.962 44.5427C173.129 42.6915 174.65 38.5266 175.139 36.6754C176.23 37.2925 178.411 37.5778 178.411 33.7831C178.411 29.9883 176.531 31.2764 175.59 32.3947L172.091 33.3203C172.543 27.767 167.916 25.1446 165.546 24.5276C165.395 26.61 163.669 32.1744 155.275 31.9321C147.263 31.7005 146.359 24.0648 146.585 20.2469C147.211 9.65086 156.893 11.8012 159.79 14.8092C165.546 9.02453 173.108 15.1564 174.8 19.4371C178.05 19.1594 181.572 22.1751 182.926 23.7177Z"
          fill={color}
        />
        <path
          d="M153.983 46.6736C152.809 44.2634 154.246 42.4248 155.11 41.8069C158.089 47.6468 163.194 48.6433 165.374 48.4116V53.3941C162.576 52.9306 160.374 55.4412 159.623 56.7544C158.231 54.3984 155.156 49.0837 153.983 46.6736Z"
          fill={color}
        />
        <path
          d="M152.698 30.6659C152.472 37.0179 155.055 49.443 167.198 48.3275C169.351 47.979 170.371 47.1655 171.504 44.9578"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M162.665 44.6877C163.155 45.217 164.612 45.9092 166.514 44.4434"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M162.937 37.4103C162.256 39.2301 161.646 42.6604 164.661 41.8241"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M176.351 33.1581C176.782 33.4571 177.383 34.2563 176.351 35.0632"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M166.229 34.0966C166.843 33.7849 168.302 33.3954 169.223 34.3304"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M156.107 35.0842C156.596 34.7715 157.822 34.417 158.816 35.5013"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M161.026 35.5757C161.026 37.9583 159.333 39.8255 157.319 39.8255C155.305 39.8255 153.612 37.9583 153.612 35.5757C153.612 33.1934 155.305 31.3259 157.319 31.3259C159.333 31.3259 161.026 33.1934 161.026 35.5757Z"
          stroke={color}
          strokeWidth="0.732723"
        />
        <path
          d="M171.718 34.6243C171.718 37.3286 169.993 39.387 168.011 39.387C166.03 39.387 164.305 37.3286 164.305 34.6243C164.305 31.9201 166.03 29.8616 168.011 29.8616C169.993 29.8616 171.718 31.9201 171.718 34.6243Z"
          stroke={color}
          strokeWidth="0.732723"
        />
        <path
          d="M157.461 39.458C158.13 39.458 158.673 39.0316 158.673 38.5055C158.673 37.9794 158.13 37.553 157.461 37.553C156.792 37.553 156.249 37.9794 156.249 38.5055C156.249 39.0316 156.792 39.458 157.461 39.458Z"
          fill={color}
        />
        <path
          d="M167.869 38.7271C168.538 38.7271 169.08 38.3335 169.08 37.8479C169.08 37.3623 168.538 36.9686 167.869 36.9686C167.199 36.9686 166.657 37.3623 166.657 37.8479C166.657 38.3335 167.199 38.7271 167.869 38.7271Z"
          fill={color}
        />
        <path
          d="M160.812 34.919C161.571 34.7184 163.321 34.4204 164.233 34.8331"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M148.09 27.0291C148.09 27.1283 147.595 28.3308 147.663 29.258C147.679 29.4698 147.518 29.6843 147.313 29.671L145.948 29.5832"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M151.807 12.6333L157.002 2.15953C157.062 2.0383 157.039 1.8926 156.93 1.81568C153.652 -0.492715 138.46 0.69915 130.995 1.61909C130.899 1.6309 130.822 1.68765 130.779 1.77682C127.559 8.57055 122.034 23.3157 125.039 29.3851C125.076 29.46 125.141 29.5111 125.221 29.529C128.082 30.1697 134.57 29.9119 137.495 29.6993"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M134.398 8.66385C136.976 8.23871 143.074 7.6435 146.84 8.66385"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M132.829 13.7668L145.607 13.0711"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M132.156 18.1719L142.693 17.2442"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M132.156 22.4589H138.77"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M137.215 31.3997C137.47 30.1633 137.829 27.2497 137.215 25.4876C136.601 23.7257 137.47 23.1306 137.982 23.0534C138.53 22.976 139.583 23.5402 139.407 26.4151"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M138.928 23.5203C138.665 22.0906 138.502 19.3307 140.213 19.238C142.194 19.7016 142.389 24.6091 142.239 27.0048"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M141.85 21.3447C142.733 21.1255 144.011 21.5015 144.278 24.1424C144.344 24.7799 144.335 25.5491 144.229 26.4739"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M144.278 24.1402C144.98 23.5186 146.316 23.1144 146.043 26.4718C145.704 30.6684 145.363 30.2021 146.27 35.7976"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M86.7651 96.2217C90.5224 100.175 97.5029 101.917 101.182 102.392C101.442 102.426 101.534 102.774 101.323 102.934L91.6419 110.274C91.6104 110.298 91.5741 110.315 91.5359 110.323C84.3681 111.968 77.6854 104.633 75.0337 100.466C74.9326 100.308 75.0079 100.097 75.183 100.036L86.4666 96.1467C86.5718 96.1104 86.6874 96.1401 86.7651 96.2217Z"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M81.2217 102.242C82.3622 101.999 84.8428 101.24 85.6411 100.155"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M84.4297 104.88C85.1425 104.904 86.782 104.543 87.6374 102.902"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M87.9224 106.638C88.9916 106.492 91.2869 105.657 91.9141 103.488"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M61.7017 77.3178C62.0299 76.8469 62.1947 76.4183 62.0451 76.1222C61.6102 75.2617 60.5405 76.145 60.0601 76.6942C58.8644 78.0156 56.5631 80.3124 57.1834 77.6397C57.8036 74.9669 56.4844 75.1315 53.3955 78.394"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M61.4506 81.5066C61.7151 82.3425 61.2908 84.2771 57.4025 84.7459C55.9314 84.9232 55.7103 84.8983 54.3296 84.7786"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M59.0928 79.8345C59.8568 79.2558 61.0753 78.2052 61.7007 77.3078C62.3799 77.2997 63.0375 77.6932 61.9894 79.0684C61.5356 79.6638 60.762 80.4431 59.532 81.4537"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
        <path
          d="M59.5332 81.465C60.7632 80.4544 61.5368 79.6751 61.9906 79.0797C62.6385 79.2674 63.2215 79.9935 61.4508 81.5097C61.0636 81.8412 60.5638 82.2106 59.9275 82.6203"
          stroke={color}
          strokeWidth="0.732723"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2682_670">
          <rect width="208" height="176" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
}
